export default "__VITE_ASSET__dc03301e__"